"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTimezoneTitles = exports.getTimezoneNames = exports.getDefaultTimezone = exports.getIsLoading = exports.getTimezones = void 0;

var _reselect = require("reselect");

var _timezones = require("./timezones.constants");

var _timezones2 = require("./timezones.helpers");

var getTimezones = function getTimezones(state) {
  return state.timezones.timezones;
};

exports.getTimezones = getTimezones;

var getIsLoading = function getIsLoading(state) {
  return state.timezones.isLoading;
};

exports.getIsLoading = getIsLoading;
var getDefaultTimezone = (0, _reselect.createSelector)(getTimezones, function (timezones) {
  return timezones.findIndex(function (item) {
    return item.name === _timezones.GUESS_TIMEZONE;
  }) !== -1 ? _timezones.GUESS_TIMEZONE : _timezones.DEFAULT_TIMEZONE_NAME;
});
exports.getDefaultTimezone = getDefaultTimezone;
var getTimezoneNames = (0, _reselect.createSelector)(getTimezones, function (timezones) {
  return timezones.map(function (item) {
    return item.name;
  });
});
exports.getTimezoneNames = getTimezoneNames;
var getTimezoneTitles = (0, _reselect.createSelector)(getTimezones, function (timezones) {
  return timezones.map(function (item) {
    return (0, _timezones2.formatTimezoneTitle)(item);
  });
});
exports.getTimezoneTitles = getTimezoneTitles;